[
  {
    "codigo": "0132",
    "nome": "AFEGANISTAO"
  },
  {
    "codigo": "0153",
    "nome": "Aland, Ilhas"
  },
  {
    "codigo": "0175",
    "nome": "ALBANIA, REPUBLICA DA"
  },
  {
    "codigo": "0230",
    "nome": "ALEMANHA"
  },
  {
    "codigo": "0256",
    "nome": "Alemanha, República Democrática da"
  },
  {
    "codigo": "0310",
    "nome": "BURKINA FASO"
  },
  {
    "codigo": "0370",
    "nome": "ANDORRA"
  },
  {
    "codigo": "0400",
    "nome": "ANGOLA"
  },
  {
    "codigo": "0418",
    "nome": "ANGUILLA"
  },
  {
    "codigo": "0420",
    "nome": "Antártica"
  },
  {
    "codigo": "0434",
    "nome": "ANTIGUA E BARBUDA"
  },
  {
    "codigo": "0477",
    "nome": "ANTILHAS HOLANDESAS"
  },
  {
    "codigo": "0531",
    "nome": "ARABIA SAUDITA"
  },
  {
    "codigo": "0590",
    "nome": "ARGELIA"
  },
  {
    "codigo": "0639",
    "nome": "ARGENTINA"
  },
  {
    "codigo": "0647",
    "nome": "ARMENIA, REPUBLICA DA"
  },
  {
    "codigo": "0655",
    "nome": "ARUBA"
  },
  {
    "codigo": "0698",
    "nome": "AUSTRALIA"
  },
  {
    "codigo": "0728",
    "nome": "AUSTRIA"
  },
  {
    "codigo": "0736",
    "nome": "AZERBAIJAO, REPUBLICA DO"
  },
  {
    "codigo": "0779",
    "nome": "BAHAMAS, ILHAS"
  },
  {
    "codigo": "0809",
    "nome": "BAHREIN, ILHAS"
  },
  {
    "codigo": "0817",
    "nome": "BANGLADESH"
  },
  {
    "codigo": "0833",
    "nome": "BARBADOS"
  },
  {
    "codigo": "0850",
    "nome": "BELARUS, REPUBLICA DA"
  },
  {
    "codigo": "0876",
    "nome": "BELGICA"
  },
  {
    "codigo": "0884",
    "nome": "BELIZE"
  },
  {
    "codigo": "0906",
    "nome": "BERMUDAS"
  },
  {
    "codigo": "0930",
    "nome": "MIANMAR (BIRMANIA)"
  },
  {
    "codigo": "0973",
    "nome": "BOLIVIA"
  },
  {
    "codigo": "0981",
    "nome": "BOSNIA-HERZEGOVINA (REPUBLICA DA)"
  },
  {
    "codigo": "0990",
    "nome": "Bonaire, Santo Eustáquio e Saba"
  },
  {
    "codigo": "1015",
    "nome": "BOTSUANA"
  },
  {
    "codigo": "1023",
    "nome": "Bouvet, Ilha"
  },
  {
    "codigo": "1058",
    "nome": "BRASIL"
  },
  {
    "codigo": "1082",
    "nome": "BRUNEI"
  },
  {
    "codigo": "1112",
    "nome": "BULGARIA, REPUBLICA DA"
  },
  {
    "codigo": "1155",
    "nome": "BURUNDI"
  },
  {
    "codigo": "1198",
    "nome": "BUTAO"
  },
  {
    "codigo": "1279",
    "nome": "CABO VERDE, REPUBLICA DE"
  },
  {
    "codigo": "1376",
    "nome": "CAYMAN, ILHAS"
  },
  {
    "codigo": "1414",
    "nome": "CAMBOJA"
  },
  {
    "codigo": "1457",
    "nome": "CAMAROES"
  },
  {
    "codigo": "1490",
    "nome": "CANADA"
  },
  {
    "codigo": "1504",
    "nome": "CANAL, ILHAS DO (JERSEY E GUERNSEY)"
  },
  {
    "codigo": "1511",
    "nome": "CANARIAS, ILHAS"
  },
  {
    "codigo": "1538",
    "nome": "CAZAQUISTAO, REPUBLICA DO"
  },
  {
    "codigo": "1546",
    "nome": "CATAR"
  },
  {
    "codigo": "1589",
    "nome": "CHILE"
  },
  {
    "codigo": "1600",
    "nome": "CHINA, REPUBLICA POPULAR"
  },
  {
    "codigo": "1619",
    "nome": "FORMOSA (TAIWAN)"
  },
  {
    "codigo": "1635",
    "nome": "CHIPRE"
  },
  {
    "codigo": "1651",
    "nome": "COCOS(KEELING),ILHAS"
  },
  {
    "codigo": "1694",
    "nome": "COLOMBIA"
  },
  {
    "codigo": "1732",
    "nome": "COMORES, ILHAS"
  },
  {
    "codigo": "1775",
    "nome": "CONGO, REPUBLICA DO"
  },
  {
    "codigo": "1830",
    "nome": "COOK, ILHAS"
  },
  {
    "codigo": "1872",
    "nome": "COREIA, REP.POP.DEMOCRATICA"
  },
  {
    "codigo": "1902",
    "nome": "COREIA, REPUBLICA DA"
  },
  {
    "codigo": "1937",
    "nome": "COSTA DO MARFIM"
  },
  {
    "codigo": "1953",
    "nome": "CROACIA (REPUBLICA DA)"
  },
  {
    "codigo": "1961",
    "nome": "COSTA RICA"
  },
  {
    "codigo": "1988",
    "nome": "COVEITE"
  },
  {
    "codigo": "1996",
    "nome": "CUBA"
  },
  {
    "codigo": "2003",
    "nome": "Curaçao"
  },
  {
    "codigo": "2291",
    "nome": "BENIN"
  },
  {
    "codigo": "2321",
    "nome": "DINAMARCA"
  },
  {
    "codigo": "2356",
    "nome": "DOMINICA,ILHA"
  },
  {
    "codigo": "2399",
    "nome": "EQUADOR"
  },
  {
    "codigo": "2402",
    "nome": "EGITO"
  },
  {
    "codigo": "2437",
    "nome": "Eritreia"
  },
  {
    "codigo": "2445",
    "nome": "EMIRADOS ARABES UNIDOS"
  },
  {
    "codigo": "2453",
    "nome": "ESPANHA"
  },
  {
    "codigo": "2461",
    "nome": "ESLOVENIA, REPUBLICA DA"
  },
  {
    "codigo": "2470",
    "nome": "ESLOVACA, REPUBLICA"
  },
  {
    "codigo": "2496",
    "nome": "ESTADOS UNIDOS"
  },
  {
    "codigo": "2518",
    "nome": "ESTONIA, REPUBLICA DA"
  },
  {
    "codigo": "2534",
    "nome": "ETIOPIA"
  },
  {
    "codigo": "2550",
    "nome": "FALKLAND (ILHAS MALVINAS)"
  },
  {
    "codigo": "2593",
    "nome": "FEROE, ILHAS"
  },
  {
    "codigo": "2674",
    "nome": "FILIPINAS"
  },
  {
    "codigo": "2712",
    "nome": "FINLANDIA"
  },
  {
    "codigo": "2755",
    "nome": "FRANCA"
  },
  {
    "codigo": "2810",
    "nome": "GABAO"
  },
  {
    "codigo": "2852",
    "nome": "GAMBIA"
  },
  {
    "codigo": "2895",
    "nome": "GANA"
  },
  {
    "codigo": "2917",
    "nome": "GEORGIA, REPUBLICA DA"
  },
  {
    "codigo": "2925",
    "nome": "Ilhas Geórgia do Sul e Sandwich do Sul"
  },
  {
    "codigo": "2933",
    "nome": "GIBRALTAR"
  },
  {
    "codigo": "2976",
    "nome": "GRANADA"
  },
  {
    "codigo": "3018",
    "nome": "GRECIA"
  },
  {
    "codigo": "3050",
    "nome": "GROENLANDIA"
  },
  {
    "codigo": "3093",
    "nome": "GUADALUPE"
  },
  {
    "codigo": "3131",
    "nome": "GUAM"
  },
  {
    "codigo": "3174",
    "nome": "GUATEMALA"
  },
  {
    "codigo": "3212",
    "nome": "Guernsey, Ilha do Canal (Inclui Alderney e Sark)"
  },
  {
    "codigo": "3255",
    "nome": "GUIANA FRANCESA"
  },
  {
    "codigo": "3298",
    "nome": "GUINE"
  },
  {
    "codigo": "3310",
    "nome": "GUINE-EQUATORIAL"
  },
  {
    "codigo": "3344",
    "nome": "GUINE-BISSAU"
  },
  {
    "codigo": "3379",
    "nome": "GUIANA"
  },
  {
    "codigo": "3417",
    "nome": "HAITI"
  },
  {
    "codigo": "3433",
    "nome": "Ilha Heard e Ilhas McDonald"
  },
  {
    "codigo": "3450",
    "nome": "HONDURAS"
  },
  {
    "codigo": "3514",
    "nome": "HONG KONG"
  },
  {
    "codigo": "3557",
    "nome": "HUNGRIA, REPUBLICA DA"
  },
  {
    "codigo": "3573",
    "nome": "IEMEN"
  },
  {
    "codigo": "3595",
    "nome": "MAN, ILHA DE"
  },
  {
    "codigo": "3611",
    "nome": "INDIA"
  },
  {
    "codigo": "3654",
    "nome": "INDONESIA"
  },
  {
    "codigo": "3697",
    "nome": "IRAQUE"
  },
  {
    "codigo": "3727",
    "nome": "IRA, REPUBLICA ISLAMICA DO"
  },
  {
    "codigo": "3751",
    "nome": "IRLANDA"
  },
  {
    "codigo": "3794",
    "nome": "ISLANDIA"
  },
  {
    "codigo": "3832",
    "nome": "ISRAEL"
  },
  {
    "codigo": "3867",
    "nome": "ITALIA"
  },
  {
    "codigo": "3883",
    "nome": "IUGOSLAVIA, REP.FED.DA"
  },
  {
    "codigo": "3913",
    "nome": "JAMAICA"
  },
  {
    "codigo": "3930",
    "nome": "Jersey, Ilha do Canal"
  },
  {
    "codigo": "3964",
    "nome": "JOHNSTON, ILHAS"
  },
  {
    "codigo": "3999",
    "nome": "JAPAO"
  },
  {
    "codigo": "4030",
    "nome": "JORDANIA"
  },
  {
    "codigo": "4111",
    "nome": "KIRIBATI"
  },
  {
    "codigo": "4200",
    "nome": "LAOS, REP.POP.DEMOCR.DO"
  },
  {
    "codigo": "4260",
    "nome": "LESOTO"
  },
  {
    "codigo": "4278",
    "nome": "LETONIA, REPUBLICA DA"
  },
  {
    "codigo": "4316",
    "nome": "LIBANO"
  },
  {
    "codigo": "4340",
    "nome": "LIBERIA"
  },
  {
    "codigo": "4383",
    "nome": "LIBIA"
  },
  {
    "codigo": "4405",
    "nome": "LIECHTENSTEIN"
  },
  {
    "codigo": "4421",
    "nome": "LITUANIA, REPUBLICA DA"
  },
  {
    "codigo": "4456",
    "nome": "LUXEMBURGO"
  },
  {
    "codigo": "4472",
    "nome": "MACAU"
  },
  {
    "codigo": "4499",
    "nome": "MACEDONIA, ANT.REP.IUGOSLAVA"
  },
  {
    "codigo": "4502",
    "nome": "MADAGASCAR"
  },
  {
    "codigo": "4525",
    "nome": "MADEIRA, ILHA DA"
  },
  {
    "codigo": "4553",
    "nome": "MALASIA"
  },
  {
    "codigo": "4588",
    "nome": "MALAVI"
  },
  {
    "codigo": "4618",
    "nome": "MALDIVAS"
  },
  {
    "codigo": "4642",
    "nome": "MALI"
  },
  {
    "codigo": "4677",
    "nome": "MALTA"
  },
  {
    "codigo": "4723",
    "nome": "MARIANAS DO NORTE"
  },
  {
    "codigo": "4740",
    "nome": "MARROCOS"
  },
  {
    "codigo": "4766",
    "nome": "MARSHALL,ILHAS"
  },
  {
    "codigo": "4774",
    "nome": "MARTINICA"
  },
  {
    "codigo": "4855",
    "nome": "MAURICIO"
  },
  {
    "codigo": "4880",
    "nome": "Mauritânia"
  },
  {
    "codigo": "4898",
    "nome": "Mayotte (Ilhas Francesas)"
  },
  {
    "codigo": "4901",
    "nome": "MIDWAY, ILHAS"
  },
  {
    "codigo": "4936",
    "nome": "MEXICO"
  },
  {
    "codigo": "4944",
    "nome": "MOLDAVIA, REPUBLICA DA"
  },
  {
    "codigo": "4952",
    "nome": "MONACO"
  },
  {
    "codigo": "4979",
    "nome": "MONGOLIA"
  },
  {
    "codigo": "4985",
    "nome": "Montenegro"
  },
  {
    "codigo": "4995",
    "nome": "MICRONESIA"
  },
  {
    "codigo": "5010",
    "nome": "MONTSERRAT,ILHAS"
  },
  {
    "codigo": "5053",
    "nome": "MOCAMBIQUE"
  },
  {
    "codigo": "5070",
    "nome": "NAMIBIA"
  },
  {
    "codigo": "5088",
    "nome": "NAURU"
  },
  {
    "codigo": "5118",
    "nome": "CHRISTMAS,ILHA (NAVIDAD)"
  },
  {
    "codigo": "5177",
    "nome": "NEPAL"
  },
  {
    "codigo": "5215",
    "nome": "NICARAGUA"
  },
  {
    "codigo": "5258",
    "nome": "NIGER"
  },
  {
    "codigo": "5282",
    "nome": "NIGERIA"
  },
  {
    "codigo": "5312",
    "nome": "NIUE,ILHA"
  },
  {
    "codigo": "5355",
    "nome": "NORFOLK,ILHA"
  },
  {
    "codigo": "5380",
    "nome": "NORUEGA"
  },
  {
    "codigo": "5428",
    "nome": "NOVA CALEDONIA"
  },
  {
    "codigo": "5452",
    "nome": "PAPUA NOVA GUINE"
  },
  {
    "codigo": "5487",
    "nome": "NOVA ZELANDIA"
  },
  {
    "codigo": "5517",
    "nome": "VANUATU"
  },
  {
    "codigo": "5568",
    "nome": "OMA"
  },
  {
    "codigo": "5665",
    "nome": "PACIFICO,ILHAS DO (POSSESSAO DOS EUA)"
  },
  {
    "codigo": "5738",
    "nome": "PAISES BAIXOS (HOLANDA)"
  },
  {
    "codigo": "5754",
    "nome": "PALAU"
  },
  {
    "codigo": "5762",
    "nome": "PAQUISTAO"
  },
  {
    "codigo": "5780",
    "nome": "Palestina"
  },
  {
    "codigo": "5800",
    "nome": "PANAMA"
  },
  {
    "codigo": "5860",
    "nome": "PARAGUAI"
  },
  {
    "codigo": "5894",
    "nome": "PERU"
  },
  {
    "codigo": "5932",
    "nome": "PITCAIRN,ILHA"
  },
  {
    "codigo": "5991",
    "nome": "POLINESIA FRANCESA"
  },
  {
    "codigo": "6033",
    "nome": "POLONIA, REPUBLICA DA"
  },
  {
    "codigo": "6076",
    "nome": "PORTUGAL"
  },
  {
    "codigo": "6114",
    "nome": "PORTO RICO"
  },
  {
    "codigo": "6238",
    "nome": "QUENIA"
  },
  {
    "codigo": "6254",
    "nome": "QUIRGUIZ, REPUBLICA"
  },
  {
    "codigo": "6289",
    "nome": "REINO UNIDO"
  },
  {
    "codigo": "6408",
    "nome": "REPUBLICA CENTRO-AFRICANA"
  },
  {
    "codigo": "6475",
    "nome": "REPUBLICA DOMINICANA"
  },
  {
    "codigo": "6602",
    "nome": "REUNIAO, ILHA"
  },
  {
    "codigo": "6653",
    "nome": "ZIMBABUE"
  },
  {
    "codigo": "6700",
    "nome": "ROMENIA"
  },
  {
    "codigo": "6750",
    "nome": "RUANDA"
  },
  {
    "codigo": "6769",
    "nome": "RUSSIA, FEDERACAO DA"
  },
  {
    "codigo": "6777",
    "nome": "SALOMAO, ILHAS"
  },
  {
    "codigo": "6781",
    "nome": "SAINT KITTS E NEVIS"
  },
  {
    "codigo": "6858",
    "nome": "SAARA OCIDENTAL"
  },
  {
    "codigo": "6874",
    "nome": "EL SALVADOR"
  },
  {
    "codigo": "6904",
    "nome": "Samoa"
  },
  {
    "codigo": "6912",
    "nome": "SAMOA AMERICANA"
  },
  {
    "codigo": "6939",
    "nome": "São Bartolomeu"
  },
  {
    "codigo": "6955",
    "nome": "SAO CRISTOVAO E NEVES,ILHAS"
  },
  {
    "codigo": "6971",
    "nome": "SAN MARINO"
  },
  {
    "codigo": "6980",
    "nome": "São Martinho (Parte Francesa)"
  },
  {
    "codigo": "6998",
    "nome": "São Martinho (Parte Holandesa)"
  },
  {
    "codigo": "7005",
    "nome": "SAO PEDRO E MIQUELON"
  },
  {
    "codigo": "7056",
    "nome": "SAO VICENTE E GRANADINAS"
  },
  {
    "codigo": "7102",
    "nome": "SANTA HELENA"
  },
  {
    "codigo": "7153",
    "nome": "SANTA LUCIA"
  },
  {
    "codigo": "7200",
    "nome": "SAO TOME E PRINCIPE, ILHAS"
  },
  {
    "codigo": "7285",
    "nome": "SENEGAL"
  },
  {
    "codigo": "7315",
    "nome": "SEYCHELLES"
  },
  {
    "codigo": "7358",
    "nome": "SERRA LEOA"
  },
  {
    "codigo": "7370",
    "nome": "Servia"
  },
  {
    "codigo": "7412",
    "nome": "CINGAPURA"
  },
  {
    "codigo": "7447",
    "nome": "SIRIA, REPUBLICA ARABE DA"
  },
  {
    "codigo": "7480",
    "nome": "SOMALIA"
  },
  {
    "codigo": "7501",
    "nome": "SRI LANKA"
  },
  {
    "codigo": "7544",
    "nome": "SUAZILANDIA"
  },
  {
    "codigo": "7552",
    "nome": "Svalbard e Jan Mayen"
  },
  {
    "codigo": "7560",
    "nome": "AFRICA DO SUL"
  },
  {
    "codigo": "7595",
    "nome": "SUDAO"
  },
  {
    "codigo": "7600",
    "nome": "Sudão do Sul"
  },
  {
    "codigo": "7641",
    "nome": "SUECIA"
  },
  {
    "codigo": "7676",
    "nome": "SUICA"
  },
  {
    "codigo": "7706",
    "nome": "SURINAME"
  },
  {
    "codigo": "7722",
    "nome": "TADJIQUISTAO, REPUBLICA DO"
  },
  {
    "codigo": "7765",
    "nome": "TAILANDIA"
  },
  {
    "codigo": "7803",
    "nome": "Tanzânia"
  },
  {
    "codigo": "7811",
    "nome": "Terras Austrais e Antárticas Francesas"
  },
  {
    "codigo": "7820",
    "nome": "TERRITORIO BRIT.OC.INDICO"
  },
  {
    "codigo": "7838",
    "nome": "DJIBUTI"
  },
  {
    "codigo": "7889",
    "nome": "CHADE"
  },
  {
    "codigo": "7919",
    "nome": "TCHECA, REPUBLICA"
  },
  {
    "codigo": "7951",
    "nome": "TIMOR LESTE"
  },
  {
    "codigo": "8001",
    "nome": "TOGO"
  },
  {
    "codigo": "8052",
    "nome": "TOQUELAU,ILHAS"
  },
  {
    "codigo": "8109",
    "nome": "TONGA"
  },
  {
    "codigo": "8150",
    "nome": "TRINIDAD E TOBAGO"
  },
  {
    "codigo": "8206",
    "nome": "TUNISIA"
  },
  {
    "codigo": "8230",
    "nome": "TURCAS E CAICOS,ILHAS"
  },
  {
    "codigo": "8249",
    "nome": "TURCOMENISTAO, REPUBLICA DO"
  },
  {
    "codigo": "8273",
    "nome": "TURQUIA"
  },
  {
    "codigo": "8281",
    "nome": "TUVALU"
  },
  {
    "codigo": "8311",
    "nome": "UCRANIA"
  },
  {
    "codigo": "8338",
    "nome": "UGANDA"
  },
  {
    "codigo": "8451",
    "nome": "URUGUAI"
  },
  {
    "codigo": "8478",
    "nome": "UZBEQUISTAO, REPUBLICA DO"
  },
  {
    "codigo": "8486",
    "nome": "VATICANO, EST.DA CIDADE DO"
  },
  {
    "codigo": "8508",
    "nome": "VENEZUELA"
  },
  {
    "codigo": "8583",
    "nome": "VIETNA"
  },
  {
    "codigo": "8630",
    "nome": "VIRGENS,ILHAS (BRITANICAS)"
  },
  {
    "codigo": "8664",
    "nome": "VIRGENS,ILHAS (E.U.A.)"
  },
  {
    "codigo": "8702",
    "nome": "FIJI"
  },
  {
    "codigo": "8737",
    "nome": "WAKE, ILHA"
  },
  {
    "codigo": "8753",
    "nome": "Wallis e Futuna, Ilhas"
  },
  {
    "codigo": "8885",
    "nome": "Congo, República Democrática do"
  },
  {
    "codigo": "8907",
    "nome": "ZAMBIA"
  },
  {
    "codigo": "8958",
    "nome": "ZONA DO CANAL DO PANAMA"
  }
]
